var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjDivider", [_vm._v(_vm._s(_vm.$t("personal.title")))]),
      _c("div", { staticClass: "top ml0" }, [
        _c(
          "div",
          { staticClass: "picture" },
          [
            _c("BjKeyImage", {
              staticClass: "avatar",
              attrs: {
                url: _vm.avatar || _vm.$getPublicImage("logo-circle.png"),
                fit: "cover",
              },
            }),
            _c(
              "BjUpload",
              {
                ref: "upload",
                staticClass: "upload mt20",
                attrs: {
                  "auto-upload": "",
                  accept: "image/png,image/jpeg",
                  "accept-list": ["image/jpeg", "image/png"],
                  "limit-size": 100,
                },
                on: { afterUpload: _vm.afterUpload },
              },
              [
                _c("el-button", { attrs: { plain: "" } }, [
                  _vm._v(_vm._s(_vm.$t("personal.avatarSetting"))),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "form" }, [
          _c("div", { staticClass: "form-item" }, [
            _c("span", { staticClass: "form-label" }, [
              _vm._v(_vm._s(_vm.$t("personal.loginName")) + "："),
            ]),
            _c("div", [_vm._v(_vm._s(_vm.userInfo.loginName))]),
          ]),
          _c("div", { staticClass: "form-item" }, [
            _c("span", { staticClass: "form-label" }, [
              _vm._v(_vm._s(_vm.$t("personal.name")) + "："),
            ]),
            _c("div", [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.show,
                      expression: "!show",
                    },
                  ],
                },
                [
                  _vm._v(" " + _vm._s(_vm.name) + " "),
                  _c("i", {
                    staticClass: "el-icon-edit ml0",
                    on: {
                      click: function ($event) {
                        return _vm.showInput(_vm.name)
                      },
                    },
                  }),
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.show,
                      expression: "show",
                    },
                  ],
                },
                [
                  _c("BjInput", {
                    staticClass: "input",
                    attrs: { maxlength: _vm.MAX_LENGTH.DEFAULT, clearable: "" },
                    model: {
                      value: _vm.editName,
                      callback: function ($$v) {
                        _vm.editName = $$v
                      },
                      expression: "editName",
                    },
                  }),
                  _c(
                    "span",
                    { staticClass: "m20", on: { click: _vm.saveName } },
                    [_vm._v(_vm._s(_vm.$t("saveText")))]
                  ),
                  _c(
                    "span",
                    { staticClass: "m20", on: { click: _vm.concalName } },
                    [_vm._v(_vm._s(_vm.$t("cancelText")))]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _c("div", { staticClass: "form-item" }, [
            _c("span", { staticClass: "form-label" }, [
              _vm._v(_vm._s(_vm.$t("personal.tenant")) + "："),
            ]),
            _c("div", [_vm._v(_vm._s(_vm.$store.getters.userInfo.tenantName))]),
          ]),
          _c("div", { staticClass: "form-item" }, [
            _c("span", { staticClass: "form-label" }, [
              _vm._v(_vm._s(_vm.$t("personal.changePassword")) + "："),
            ]),
            _c("div", [_vm._v("******")]),
            _c("i", {
              staticClass: "el-icon-edit ml0",
              on: { click: _vm.change },
            }),
          ]),
          _c("div", { staticClass: "form-item" }, [
            _c("span", { staticClass: "form-label" }, [
              _vm._v(_vm._s(_vm.$t("personal.validityPeriod")) + "："),
            ]),
            _c("div", [_vm._v("2020-12-12")]),
          ]),
          _vm.$store.getters.cusId
            ? _c("div", { staticClass: "form-item" }, [
                _c("span", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$t("personal.APIKey")) + "："),
                ]),
                _vm.userInfo.apiKey
                  ? _c("div", [_vm._v(_vm._s(_vm.userInfo.apiKey))])
                  : _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.getApiKey(_vm.userInfo.cusId)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("personal.APIbtn")))]
                        ),
                      ],
                      1
                    ),
              ])
            : _vm._e(),
        ]),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("personal.changePassword"),
            visible: _vm.passDialogVisible,
            width: "420px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.passDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 22 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "passForm",
                      attrs: { model: _vm.passForm, rules: _vm.passRules },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "originalPassword",
                            label: _vm.$t("personal.originalPassword"),
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              maxlength: _vm.MAX_LENGTH.DEFAULT,
                              placeholder: _vm.$t(
                                "personal.originalPasswordText"
                              ),
                              "show-password": "",
                            },
                            model: {
                              value: _vm.passForm.originalPassword,
                              callback: function ($$v) {
                                _vm.$set(_vm.passForm, "originalPassword", $$v)
                              },
                              expression: "passForm.originalPassword",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "password",
                            label: _vm.$t("personal.newPassword"),
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              maxlength: _vm.MAX_LENGTH.DEFAULT,
                              placeholder: _vm.$t("personal.newPasswordText"),
                              "show-password": "",
                            },
                            model: {
                              value: _vm.passForm.password,
                              callback: function ($$v) {
                                _vm.$set(_vm.passForm, "password", $$v)
                              },
                              expression: "passForm.password",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "checkPass",
                            label: _vm.$t("personal.checkPass"),
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              maxlength: _vm.MAX_LENGTH.DEFAULT,
                              placeholder: _vm.$t("personal.checkPassText"),
                              "show-password": "",
                            },
                            model: {
                              value: _vm.passForm.checkPass,
                              callback: function ($$v) {
                                _vm.$set(_vm.passForm, "checkPass", $$v)
                              },
                              expression: "passForm.checkPass",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitPassForm("passForm")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("personal.mobileBinding"),
            visible: _vm.phoneDialogVisible,
            width: "420px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.phoneDialogVisible = $event
            },
          },
        },
        [_c("el-row", [_vm._v(_vm._s(_vm.$t("personal.none")))])],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("personal.emailBinding"),
            visible: _vm.emailDialogVisible,
            width: "420px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.emailDialogVisible = $event
            },
          },
        },
        [_c("el-row", [_vm._v(_vm._s(_vm.$t("personal.none")))])],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("personal.verifyPassword"),
            visible: _vm.checkDialogVisible,
            width: "420px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.checkDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 22 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "checkForm",
                      attrs: { model: _vm.checkForm, rules: _vm.checkRules },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "pwd",
                            label: _vm.$t("personal.passwordValidation"),
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              maxlength: _vm.MAX_LENGTH.DEFAULT,
                              placeholder: _vm.$t("personal.enterPasswordText"),
                              "show-password": "",
                            },
                            model: {
                              value: _vm.checkForm.pwd,
                              callback: function ($$v) {
                                _vm.$set(_vm.checkForm, "pwd", $$v)
                              },
                              expression: "checkForm.pwd",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitCheckForm("checkForm")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }